<!-- 手机登录 -->
<template>
  <div class="phone_login_form">
    <a-form :form="form">
      <a-form-item :validate-status="formRules.phone.status" :help="formRules.phone.msg">
        <a-input
          placeholder="请输入11位手机号"
          size="large"
          :maxLength="11"
          oninput="value=value.replace(/[^\d]/g,'')"
          @change="e => formRules.phone.validator(e.target.value)"
          @keyup.enter.native="getCode"
        >
          <a-icon slot="prefix" type="user" class="f-icon-color" />
        </a-input>
      </a-form-item>

      <a-form-item :validate-status="formRules.code.status" :help="formRules.code.msg">
        <div style="display: flex; align-items: center">
          <!-- 
						@change="e => setFormValue('code', e.target.value)"
           -->
          <a-input
            placeholder="验证码"
            size="large"
            :maxLength="8"
            oninput="value=value.replace(/[^\d]/g,'')"
            @change="e => formRules.code.validator(e.target.value)"
            @keyup.enter.native="handleLogin"
          >
            <a-icon slot="prefix" type="lock" class="f-icon-color" />
          </a-input>

          <a-spin :spinning="codeLoading">
            <a-button v-if="!isGetCode" class="get_code_btn" @click="getCode">
              获取验证码
            </a-button>
            <a-button v-else class="get_code_btn"> {{ residueSeconds }}秒后重发 </a-button>
          </a-spin>
        </div>
      </a-form-item>

      <div v-if="loginType === '2'" class="first_wx_bind_msg">
        首次使用微信扫码登录需先绑定账号，后续只需要使用微信扫码即可完成自动登录。
      </div>

      <!-- 扫码首次绑定登录，这里不显示 -->
      <div v-else class="check_agree_box">
        <a-checkbox :checked="isCheckAgree" @change="handleChangeAgree">
          登录即代表同意<a
            target="_blank"
            style="color: #1890ff"
            :href="settings.loginAgreement.url"
          >
            《{{ settings.loginAgreement.name }}》
          </a>
        </a-checkbox>
      </div>

      <!-- <a-form-item :wrapper-col="{ span: 12, offset: 5 }"> -->
      <a-button
        size="large"
        type="primary"
        style="width: 100%; height: 40px;"
        :loading="submitLoading"
        @click="handleLogin"
      >
        {{ loginType == '2' ? '绑定并登录' : '登 录' }}
      </a-button>
      <!-- </a-form-item> -->
    </a-form>

    <!-- 选择登录账号-弹窗 -->
    <ChooseLoginAccountModal ref="chooseLoginAccountModalRef" @choose="selectCompany" />
  </div>
</template>

<script>
import ChooseLoginAccountModal from './chooseLoginAccountModal.vue'
import * as loginApi from '@/api/login.api'
import cookie from '@/commomFun/cookie.js'
import settings from '@/settings'

let timer = null

function validatePhone(phone) {
  return /^1\d{10}$/.test(phone)
}

export default {
  name: 'phoneLoginForm',
  components: {
    ChooseLoginAccountModal
  },
  // emits: [],
  props: {
    // 登录方式 1：手机登录 2：密码登录 3：扫码登录
    loginType: {
      type: String,
      default: '1'
    },
    wxUserInfo: {
      type: Object,
      default: () => ({
        unionId: '',
        openId: ''
      })
    }
  },
  data() {
    return {
      settings,
      isCheckAgree: false,
      submitLoading: false,
      codeLoading: false,
      isGetCode: false,
      residueSeconds: 60,
      form: this.$form.createForm(this),
      formData: {
        // 手机号
        phone: '',
        // 验证码
        code: ''
      },
      formRules: {
        phone: {
          validator: value => {
            if (!value) {
              return this.setRule('phone', '手机号码不能为空', value)
            }
            if (!validatePhone(value)) {
              return this.setRule('phone', '手机号码格式不正确', value)
            }
            return this.setRule('phone', '', value)
          },
          status: '',
          msg: null
        },
        code: {
          validator: value => {
            if (!value) {
              return this.setRule('code', '验证码不能为空', value)
            }
            return this.setRule('code', '', value)
          },
          status: '',
          msg: null
        }
      }
    }
  },
  methods: {
    handleChangeAgree(e) {
      this.isCheckAgree = e.target.checked
    },
    /**
     * 主动校验表单项
     */
    validateRule(fieldList = []) {
      return fieldList.every(field => {
        return this.formRules[field].validator(this.formData[field])
      })
    },

    /**
     * 自定义表单项校验
     */
    setRule(field, errorMsg, value) {
      const isPass = !errorMsg
      this.formRules[field].status = isPass ? 'success' : 'error'
      this.formRules[field].msg = errorMsg
      if (value !== void 0) this.setFormValue(field, value)
      return isPass
    },

    /**
     * 设置表单值
     */
    setFormValue(field, value) {
      this.formData[field] = value
    },

    /**
     * 获取验证码
     */
    async getCode(e) {
      try {
        if (this.codeLoading || this.isGetCode) return
        if (!this.validateRule(['phone'])) return
        this.codeLoading = true
        const res = await loginApi.sendVerifyCode({
          phone: this.formData.phone
        })
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        this.$message.success('验证码发送成功')
        this.isGetCode = true
        this.startCodeCountDown()
      } catch (err) {
        console.error('getCode error:', err)
      } finally {
        this.codeLoading = false
      }
    },

    /**
     * 验证码倒计时
     */
    startCodeCountDown() {
      timer = setInterval(() => {
        this.residueSeconds--
        if (this.residueSeconds <= 0) {
          clearInterval(timer)
          this.isGetCode = false
          this.residueSeconds = 60
        }
      }, 1000)
    },

    /**
     * 点击登录
     */
    async handleLogin() {
      if (!this.isCheckAgree && this.loginType == '1') {
        this.$message.warning(`请勾选同意《${settings.loginAgreement.name}》`)
        return
      }
      if (this.submitLoading) return
      try {
        if (!this.validateRule(['phone', 'code'])) return
        console.log('handleLogin =====', this.formData)
        this.submitLoading = true
        const res = await loginApi.loginUserList({ ...this.formData })
        const { code, msg, data: list } = res.data || {}
        if (code !== 200) return this.$message.error(msg)
        if (!list.length) {
          return this.$message.error('该手机号未注册')
        }
        if (list.length === 1) {
          this.selectCompany(list[0])
        } else {
          this.$refs.chooseLoginAccountModalRef && this.$refs.chooseLoginAccountModalRef.open(list)
        }
      } catch (err) {
        console.error('handleLogin error:', err)
      } finally {
        this.submitLoading = false
      }
    },

    /**
     * 选择角色/公司
     */
    async selectCompany({ companyId, roleId, userName, appId }) {
      try {
        // console.log('selectCompany =====:', {
        //   ...formData,
        //   companyId,
        //   roleId,
        //   userName,
        //   fromWxQrCode: props.loginType === '3',
        //   wxOpenId: props.wxUserInfo.openId,
        //   wxUnionId: props.wxUserInfo.unionId
        // })
        // return

        this.submitLoading = true
        // 验证码登录
        const res = await loginApi.phoneCodeLogin(
          {
            ...this.formData,
            companyId,
            roleId,
            userName,
            fromWxQrCode: this.loginType === '2',
            wxOpenId: this.wxUserInfo.openId,
            wxUnionId: this.wxUserInfo.unionId
          },
          { appId }
        )
        const { code, msg, data } = res.data || {}
        if (code !== 200) return this.$message.error(msg)

        cookie.setCookie('token', data.token, 7)
        cookie.setCookie('uid', data.userId, 7)
        sessionStorage.setItem('account', this.formData.phone)
        // sessionStorage.setItem('passwork', this.$refs.passworkInput.value)
        sessionStorage.setItem('userInfo', JSON.stringify(data))
        sessionStorage.setItem('asrId', data.asrId)
        //超管或广告运营
        if ([1, 4, 6].indexOf(data.userType) !== -1) {
          this.$router.push('/index')
        } else if (data.userType == 3) {
          //工程
          this.$router.push('/adPackage')
        } else {
          this.$router.push('/channelAdPlan')
        }

        // 缓存本次登录方式
        localStorage.setItem('lastLoginType', this.loginType)
      } catch (err) {
        console.error('selectCompany error:', err)
      } finally {
        this.submitLoading = false
      }
    }
  },

  mounted() {
    this.isCheckAgree = !!localStorage.getItem('lastLoginType')
  },

  beforeDestroy() {
    clearInterval(timer)
  }
}
</script>

<style lang="scss" scoped>
.phone_login_form {
  :deep(.ant-input-affix-wrapper) {
    border-radius: 0;
  }
  :deep(.ant-btn) {
    border-radius: 0;
  }
  .get_code_btn {
    width: 102px;
    height: 40px;
    margin-left: 10px;
  }
}

.first_wx_bind_msg {
  width: 368px;
  color: #e0282e;
  font-size: 14px;
  line-height: 20px;
  margin: 10px auto;
}

.check_agree_box {
  margin-bottom: 12px;
  text-align: center;
}
</style>
